import React from "react";

import useUserSettings from "@app/analytics/hooks/settings/useUserSettings";
import useFeatureAccess from "@app/common/hooks/useFeatureAccess";
import * as UserSettingsUtils from "@app/common/utils/userSettingsUtils";

import ReportingSettingAccordion from "../ReportingSettingAccordion";

const MeetingLinkSetting = () => {
  const { userSettings, updateUserSettings } = useUserSettings();
  const { canEditShareLinkInBotMessage } = useFeatureAccess();

  const handleToggleEnabled = (enable: boolean) => {
    updateUserSettings.mutate({ shareLinkInBotMessage: enable });
  };

  const disabledProps = UserSettingsUtils.getSettingDisabledOpts({
    settingIsEditable: canEditShareLinkInBotMessage,
    custom: {
      condition: userSettings.externalParticipantAccessLevel === "no_access",
      tooltip: "Not available based on your Participant Access settings",
    },
  });

  return (
    <ReportingSettingAccordion
      title="Link in Meeting Chat"
      subtitle="During the meeting, send a link in chat to access metrics and reporting"
      onToggleEnabled={handleToggleEnabled}
      enabled={Boolean(userSettings?.shareLinkInBotMessage)}
      opts={{
        expandable: false,
        disabled: disabledProps.disabled,
        disabledTooltip: disabledProps.tooltip ?? "",
      }}
    >
      <React.Fragment />
    </ReportingSettingAccordion>
  );
};

export default MeetingLinkSetting;
